module.exports = __webpack_public_path__ + "media/categories/3019-e19615bf.svg";